import { RootState } from 'store';

export const selectors = {
  selectAccessToken: (state: RootState) => state.auth.accessToken,
  selectEmail: (state: RootState) => state.auth.email,
  selectIsLandingPage: (state: RootState) => state.auth.isLandingPage,
};
